import { render, staticRenderFns } from "./StoryContentRenderer.vue?vue&type=template&id=b53c9c82&scoped=true"
import script from "./StoryContentRenderer.vue?vue&type=script&lang=js"
export * from "./StoryContentRenderer.vue?vue&type=script&lang=js"
import style0 from "./StoryContentRenderer.vue?vue&type=style&index=0&id=b53c9c82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53c9c82",
  null
  
)

export default component.exports